import React, { Component } from 'react';
import FakeData from '.././fake-data';
import {
	Register,
	_HomeLogin
} from '../App'

export default class HomePage extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}

	render() {
		return (
			<div style={{
				marginTop: '-10px'
			}}>
				<meta charSet="UTF-8" />
				<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1"
				/>
				<title>Supotsu</title>
				<link href="css/mijsports.css" rel="stylesheet" />
				<link href="css/slider.css" rel="stylesheet" />
				<link href="css/select.css" rel="stylesheet" />
				<link href="fancybox/jquery.fancybox.css" rel="stylesheet" />
				{/* Modify */}
				<link href="/css_1/style_1.css" rel="stylesheet" type="text/css" />
				<link
					href="css/modify/tagmanager.css"
					rel="stylesheet"
					type="text/css"
				/>
				<link
					href="css/modify/modify.css"
					rel="stylesheet"
					type="text/css"
				/>
				<link
					href="css/modify/font-awesome/css/font-awesome.min.css"
					rel="stylesheet"
					type="text/css"
				/>
				<link
					type="text/css"
					rel="stylesheet"
					href="https://fonts.googleapis.com/css?family=Roboto:300,400,500"
				/>
				<link
					rel="stylesheet"
					href="//code.jquery.com/ui/1.12.0/themes/base/jquery-ui.css"
				/>
				<link
					href="https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.3/css/select2.min.css"
					rel="stylesheet"
				/>
				<link
					rel="stylesheet"
					href="css/modify/jquery.Jcrop.css"
					type="text/css"
				/>
				{/* end Modify */}
				{/* HTML5 shim and Respond.js for IE8 support of HTML5 elements and media queries */}
				{/* WARNING: Respond.js doesn't work if you view the page via file:// */}
				{/*[if lt IE 9]>
        
        
      <![endif]*/}
				<link
					rel="stylesheet"
					href="http://sport.bigwebdev.co.za/font-awesome/css/font-awesome.min.css"
				/>
				<link rel="stylesheet" type="text/css" href="css/style1.css" />
				<style
					dangerouslySetInnerHTML={{
						__html:
							".login_logo_holder{ display:none;}\n.logtext h3{ color:#fff;}\n.logtext h1{ color:#fff;}\n.logtext h2{ color:#fff;}\n.logtext p{ color:#fff;}\n.logtext{ float:left!important;\n}\n.pad ul {\n\tmargin: 0;\n\tpadding: 0;\n\tpadding-left: 10px;\n\n}.btn_facebook, .btn_twitter, .btn_google {\n  -moz-user-select: none;\n  background-repeat: no-repeat;\n  border: medium none;\n  border-radius: 0;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  font-size: 15px;\n  font-weight: normal;\n  height: 30px;\n  line-height: 30px;\n  margin: 5px 0;\n  max-width: 50px;\n  padding: 0 20px !important;\n  text-align: left;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto !important;\n}\n.login{width: 15.667%;}\n.login h6 {\n  color: #fff;\n  font-size: 14px;\n}\n.full-width {\n\twidth: 100% !important;\n\tz-index: 1000;\n\tposition: relative;\n}\n.pad ul li{\tline-height: 23px;}\n.pad h2 {\n\tbackground-image: url(http://sport.bigwebdev.co.za/img/header.jpg);\n\tbackground-repeat: no-repeat;\n\tpadding-top: 5px;\n}\n.log{ float:right!important;}"
					}}
				/>
				<HomeSliderView/>
				<div className="full-width" style={{ backgroundColor: "#374352" }}>
					<div
						className="container container-table"
						style={{ margin: "0 auto", padding: "1%", paddingTop: 10, display: 'flex', alignItems: 'center' }}
					>
						<div className="col-md-3">
							<img
								style={{ zoom: 1.5 }}
								src="images/supotsu_logo.svg"
								className="login_logo"
								alt="Supotsu"
							/>
						</div>
						<div className="col-md-3" />
						<_HomeLogin {...this.props} />
					</div>
				</div>
				<div
					className="container container-table"
					style={{ height: "auto" }}
				>
					<div className="row vertical-center-row full-width part">
						<div className="col-md-4 log">
							<div className="login_form">
								{
									<Register.Home {...this.props} />
								}
							</div>
						</div>
						<div className="col-md-8 logtext vertical-center-row ">
							<h1>
								<strong>supōtsu</strong>
							</h1>
							<p>Pronounced supo-tsu it means Sport in Japanese</p>
							<br />{" "}
							<b style={{ color: "#fff", fontSize: 16 }}>Definition</b>
							<h2>
								{" "}
								supōtsu is your sport social networking site where all
								sports players, coaches, clubs, teams, leagues, fans,
								parents and you connect, talk sports and come together
								around the game.
        </h2>
							<h3>
								<strong>
									Join for Free, and connect with everyday sports players
            and fans just like you.{" "}
								</strong>
							</h3>
						</div>
					</div>
				</div>
				<br />
				<div
					className="full-width middle tile"
					style={{ backgroundColor: "#fff" }}
				>
					<div className="container container-table pads">
						<div
							className="row vertical-center-row full-width part"
							style={{ textAlign: "center" }}
						>
							<br />
							<br />
							<p />
							<h1>
								A Simple App With Powerful Team Management Features Try It
								Free, and Discover How Much Time You'll Save Each Week
        </h1>
							<br />
							<br />
							<p />
						</div>
					</div>
				</div>
				<div
					className="full-width middle"
					style={{ backgroundColor: "#efefef", padding: "2%" }}
				>
					<div
						className="container container-table pad"
						style={{ margin: "0 auto" }}
					>
						<div className="col-md-6" style={{ padding: "5%" }}>
							<h2>Clubs, Teams and Leagues</h2>
							<p>
								We have developed a complete easy to use sports team
								management tool and platform that supports everyone
								connected to the club, team and league no matter what their
								role. From player contact information, to team training,
								player availability to game management and Player
          communication we have you covered.{" "}
							</p>
						</div>
						<div className="col-md-6">
							<img
								style={{ width: "100%" }}
								src="http://sport.bigwebdev.co.za/img/personal.png"
							/>
						</div>
					</div>
				</div>
				<div
					className="full-width middle"
					style={{ backgroundColor: "#fff", padding: "2%" }}
				>
					<div
						className="container container-table pad"
						style={{ margin: "0 auto" }}
					>
						<div className="col-md-6">
							<img
								style={{ width: "100%" }}
								src="http://sport.bigwebdev.co.za/img/game-coverage.png"
							/>
						</div>
						<div className="col-md-6" style={{ padding: "5%" }}>
							<h2 className="titles">Personal Profile</h2>
							<p>
								Create your very own professional looking sports profile of
								sports you play and follow. Parents and fans can comment on
								games, become a member of a club or a team and record the
								games you played, the goals you scored, or even who you
								played against.
        </p>
							<ul>
								<li>Comment on Games </li>
								<li>Photo/Video Sharing </li>
								<li>Statistics</li>
								<li>Training schedules </li>
								<li>Messages </li>
								<li>Training Material</li>
							</ul>
						</div>
					</div>
				</div>
				<div
					className="full-width middle"
					style={{ backgroundColor: "#efefef", padding: "2%" }}
				>
					<div
						className="container container-table pad"
						style={{ margin: "0 auto" }}
					>
						<div className="col-md-6" style={{ padding: "5%" }}>
							<h2>Real Time Game coverage</h2>
							<p>
								Experience the magic of the Game in Real-time with friends,
								fans, team mates, parents and even rivals! Just like any
								professional game you view online, you will experience, blow
          by blow the highs and lows of the game.{" "}
							</p>
							<ul>
								<li>Real-time game stats</li>
								<li>Live Commentary</li>
								<li>Engage with Fans, Friends &amp; Rivals</li>
								<li>Photos/Videos</li>
							</ul>
						</div>
						<div className="col-md-6">
							<img
								style={{ width: "100%" }}
								src="http://sport.bigwebdev.co.za/img/personal.png"
							/>
						</div>
					</div>
				</div>
				<div
					className="full-width middle"
					style={{ backgroundColor: "#fff", padding: "2%" }}
				>
					<div
						className="container container-table pad"
						style={{ margin: "0 auto" }}
					>
						<div className="col-md-6">
							<img
								style={{ width: "100%" }}
								src="http://sport.bigwebdev.co.za/img/console.png"
							/>
						</div>
						<div className="col-md-6" style={{ padding: "5%" }}>
							<h2>Game Management Console</h2>
							<p>
								Aimed at schools, universities and office leagues, the Game
								Management Console and offers game score keepers the ability
								to create a game, assign scores, fowls and player positions,
								together with a running text-based commentary on each game
          in real-time.{" "}
							</p>
							<ul>
								<li>Create a game</li>
								<li>Choose a venue, date and teams</li>
								<li>Assign Players</li>
								<li>Start/stop a game</li>
								<li>Assign scores</li>
								<li>Real-time Running commentary. </li>
							</ul>
						</div>
					</div>
				</div>
				{/* BOTTOM MENU */}
				{this.is &&
				<div className="friends_online">
					<div className="friends_online_inner">
						<div className="bottom_menu_avatar">
							<img src="images/default_avatar.svg" alt="My Avatar" />
						</div>
						<div className="bottom_menu_avatar">
							<img src="images/default_avatar.svg" alt="My Avatar" />
						</div>
						<div className="bottom_menu_avatar">
							<div className="friend_activity">5</div>
							<img src="images/default_avatar.svg" alt="My Avatar" />
						</div>
						<div className="bottom_menu_avatar">
							<div className="friend_activity">3</div>
							<img src="images/default_avatar.svg" alt="My Avatar" />
						</div>
						<div className="bottom_menu_avatar">
							<div className="friend_activity">1</div>
							<img src="images/default_avatar.svg" alt="My Avatar" />
						</div>
						<div className="bottom_menu">5 Friends Online</div>
					</div>
				</div>}
				{this.is && <div className="footer" />}
				{/* Modify*/}
				{/* end Modify*/}
			</div>

		)
	}
}

class HomeSliderView extends Component{
	constructor(p){
		super(p)
		this.state = {

		}
	}

	render(){
		return(
			<ul className={"home-slider-view cb-slideshow"}>
				{
					['images/1.jpg','images/2.jpg','images/3.jpg','images/4.jpg','images/5.jpg','images/6.jpg'].map((image, i)=>{
						return(
							<li key={i}><span></span><div></div></li>
						)
					})
				}
			</ul>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/HomePage.js